import type { CampaignState } from "@/lib/scheduledCampaign";
import { CAMPAIGN_PREVIEW_PARAM } from "@/lib/resolveBanners";

/** Studio copy for each campaign state (status field and document preview). */
export const CAMPAIGN_STATUS: Record<CampaignState, { icon: string; label: string; color: string }> = {
  disabled: { icon: "⚪", label: "Disabled", color: "#8a8f98" },
  missingDates: { icon: "🟡", label: "Missing dates", color: "#d4a72c" },
  scheduled: { icon: "🟡", label: "Scheduled", color: "#d4a72c" },
  live: { icon: "🟢", label: "Live", color: "#3fa45b" },
  ended: { icon: "🔴", label: "Ended", color: "#dc4b38" },
};

// the editor's locale and timezone, like the datetime inputs
const formatDate = (value?: string) =>
  value
    ? new Date(value).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" })
    : "";

export function campaignStatusHeadline(state: CampaignState, startDate?: string, endDate?: string) {
  switch (state) {
    case "disabled":
      return "The site shows the standard banner.";
    case "missingDates":
      return "Will not go live until Start Date and End Date are both set.";
    case "scheduled":
      return `Starts ${formatDate(startDate)}. After publishing, preview it on any page with ?${CAMPAIGN_PREVIEW_PARAM}=1.`;
    case "live":
      return `Ends ${formatDate(endDate)}. The site is showing the campaign banner.`;
    case "ended":
      return `Ended ${formatDate(endDate)}. The site is back to the standard banner by itself.`;
  }
}

/** One line for the document preview, e.g. "🟢 LIVE · ends 13 Oct 2026, 18:00". */
export function campaignStatusSummary(state: CampaignState, startDate?: string, endDate?: string) {
  const { icon, label } = CAMPAIGN_STATUS[state];
  const when =
    state === "scheduled"
      ? ` · starts ${formatDate(startDate)}`
      : state === "live"
        ? ` · ends ${formatDate(endDate)}`
        : state === "ended"
          ? ` · ended ${formatDate(endDate)}`
          : "";
  return `${icon} ${label.toUpperCase()}${when}`;
}
